import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ErrorBoundary from "@/components/base/ErrorBoundary";
import { PatientSessionProvider } from "@/providers/PatientSessionProvider";
import ImpersonationBanner from "@/components/feature/ImpersonationBanner";
import MagicLinkGate from "@/components/feature/MagicLinkGate";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter basename={__BASE_PATH__}>
        {/* Sessão do Portal do Paciente fica ACIMA das rotas: é restaurada uma
            única vez no carregamento inicial e não é desmontada durante a
            navegação interna (ex.: /paciente → /paciente/especialidade → /paciente),
            evitando que "Restaurando sessão..." reapareça ao voltar. */}
        <MagicLinkGate>
          <PatientSessionProvider>
            <AppRoutes />
          </PatientSessionProvider>
        </MagicLinkGate>
        {/* "Entrar como" do /admin: faixa fixa com "Voltar ao admin" em qualquer tela. */}
        <ImpersonationBanner />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
